import { render } from "./AlignLeft.vue?vue&type=template&id=33c2f1f2"
import script from "./AlignLeft.vue?vue&type=script&lang=js"
export * from "./AlignLeft.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-management\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__